import {
  AnimatedDNAStrands,
  AnimatedMedia,
  AnimatedPerf,
  AnimatedPreorder,
} from "../../shared/SVGComponents";
import { menuTitles, screenHues, screens } from "../../../constants/constants";
import { MenuColumn } from "./MenuColumn";
import { useWindowSize } from "../../../hooks/useWindowSize";

export const ScreenMenuColumns = ({
  active,
  setActive,
  onCurtainStart,
}: any) => {
  const delayStep = 150;
  const columnProps = [
    {
      active: active === 0,
      id: 0,
      number: "01",
      menuTitle: menuTitles.product,
      subTitle: "LEARN MORE",
      rectangleButtonText: "LEARN MORE",
      curtainTo: screens.product,
      subText:
        "IOCO's Biocomputer feature for feature beats the performance of conventional computers.",
      bulletPoints: [
        "Fast Synthetic DNA Storage",
        "Quantum Decoherent Molecular Parallel Computing Unit",
        "Molecular wiring",
      ],
      svgComponent: <AnimatedDNAStrands active={active === 0} />,
      showColumnContentDelay: 1 * delayStep,
      videoStyle: {
        filter: screenHues.product,
      },
      videoStartSecond: 0,
    },
    {
      active: active === 1,
      id: 1,
      number: "02",
      menuTitle: menuTitles.performance,
      subTitle: "OUR RESULTS",
      rectangleButtonText: "OUR RESULTS",
      curtainTo: screens.performance,
      subText:
        "Powered by advanced synthetic DNA Compute Engines, IOCO's Biocomputer performance is unrivaled.",
      bulletPoints: [
        "Better than Quantum Computing",
        "Merging Biology and Computer Science",
        "Quantum Decoherence Engine for reliable prediction models",
      ],
      svgComponent: <AnimatedPerf active={active === 1} />,
      showColumnContentDelay: 2 * delayStep,
      videoStyle: {
        filter: screenHues.performance,
      },
      videoStartSecond: 1.5,
    },
    {
      active: active === 2,
      id: 2,
      number: "03",
      menuTitle: menuTitles.media,
      subTitle: "SHOW MEDIA",
      rectangleButtonText: "SHOW MEDIA",
      curtainTo: screens.media,
      subText: "Watch IOCO's Biocomputer take on impossible tasks",
      bulletPoints: [
        "Exponential Growth Molecular Strain Programming",
        "Error-Correcting Regenerative Molecular Programming",
        "Watch the Precog Engine achieve Real Time Human Intuition Sense",
      ],
      svgComponent: <AnimatedMedia active={active === 2} />,
      showColumnContentDelay: 3 * delayStep,
      videoStyle: {
        filter: screenHues.media,
      },
      videoStartSecond: 3,
    },
    {
      active: active === 3,
      id: 3,
      number: "04",
      menuTitle: menuTitles.preorder,
      subTitle: "BIO COMPUTER",
      rectangleButtonText: "BIO COMPUTER",
      curtainTo: screens.preorder,
      subText:
        "Preorder IOCO's Biocomputer now to start experimenting with the future",
      bulletPoints: [
        "Molecular Lab Setup Included",
        "30 Day Money Back Warranty",
        "Deploy your own On-Premise Molecular Server in 24h",
      ],
      svgComponent: <AnimatedPreorder active={active === 3} />,
      showColumnContentDelay: 4 * delayStep,
      videoStyle: {
        filter: screenHues.preorder,
      },
      videoStartSecond: 4.5,
    },
  ];

  const { horizontal } = useWindowSize();

  return (
    <div
      id="ScreenMenuColumns"
      style={{
        height: "100%",
        display: "grid",
        gridTemplateColumns: horizontal ? "repeat(4, 30%)" : "repeat(4, 100%)",
        overflowY: "auto" /* for the controlled scroll  */,
        scrollbarColor: "transparent",
      }}
    >
      {columnProps.map((menuColumnProps, i) => {
        return (
          <MenuColumn
            {...{
              ...menuColumnProps,
              key: i,
              setActive,
              onCurtainStart,
            }}
          />
        );
      })}
    </div>
  );
};
